module.exports = __webpack_public_path__ + "static/demo-screen-5-2fa854642183b2b6b9510c1ed2e955d7.jpg";